// extracted by mini-css-extract-plugin
module.exports = {"form-input":"AddInvestor_form-input__mQFiK","content":"AddInvestor_content__3oGQA"};